import LeaderSpotlight from './LeaderSpotlight';

export default LeaderSpotlight;
